import { render, staticRenderFns } from "./chooseResourceStore2.vue?vue&type=template&id=5ccac0ca&scoped=true"
import script from "./chooseResourceStore2.vue?vue&type=script&lang=js"
export * from "./chooseResourceStore2.vue?vue&type=script&lang=js"
import style0 from "./chooseResourceStore2.vue?vue&type=style&index=0&id=5ccac0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccac0ca",
  null
  
)

export default component.exports